

export const PROJECTS = [
  {
    name: "Todo App",
    description: "A simple todo app built with ReactJs",
    githubUrl: "https://github.com/CABON-TECH/Todo-app"
  },
  {
    name: "Expense tracker",
    description: "A simple expense tracker built with ReactJs",
    githubUrl: "https://github.com/CABON-TECH/react-expense-tracker"
  },
  {
    name: "hospital management system",
    description: "A simple hospital management system built with ReactJs",
    githubUrl: " https://github.com/CABON-TECH/Tiba-hospital-management-system"
  },
  {
    name: "AirBnB Clone",
    description: "A simple AirBnB clone built with html and css",
    githubUrl: "https://github.com/CABON-TECH/AirBnB_clone"
  },
  {
    name: "Real estate management system",
    description: "A simple real estate management system built with vanilla javascript",
    githubUrl: "https://github.com/CABON-TECH/real-estate-management-system"
  },
 
];

export const SKILLS = [
  { name: "ReactJs", initialRating: 4 },
  { name: "JavaScript", initialRating: 4 },
  { name: "Angular", initialRating: 4 },
  { name: "Redux", initialRating: 4 },
  { name: "Nodejs", initialRating: 3 },
  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  { name: "Python", initialRating: 3 },
  { name: "Flask", initialRating: 3 },
  { name: "C", initialRating: 3 },
  { name: "C++", initialRating: 3 },
  { name: "MongoDB", initialRating: 3 },
  { name: "MySQL", initialRating: 3 },
  { name: "PostgreSQL", initialRating: 3 },
  { name: "Firebase", initialRating: 3 },
  { name: "Unit-Testing(Jest)", initialRating: 3 },
  { name: "TypeScript", initialRating: 4 },
  { name: "Graphql", initialRating: 4 },
  { name: "AntD | ReactStrap | Material UI", initialRating: 4 },
  { name: "Git", initialRating: 4 },
];

export const TOOLS = ["Visual Studio Code", "Git", "Chrome DevTools", "Npm (Node Package Manager)", "Atom", "Sublime Text", "Linux", "Heroku", "Netlify",  "Postman"]
